import { defineStore } from "pinia";
import Cookies from "js-cookie";

export function getRandomNickname() {
    const anonymousNicknames = ["小貓", "星星", "小雲", "小兔", "小樹", "小河", "風車", "水滴", "小鹿", "氣球", "海豚", "萊姆", "毛球", "小熊", "綿羊", "微風", "貓頭鷹", "小龜", "小星", "蜜蜂", "夜燈", "雲朵", "彩虹", "蘋果", "橙子", "香蕉", "葡萄", "小魚", "小狗", "小馬", "小豬", "小象", "松鼠", "小雞", "小鴨", "小草", "陽光", "月亮", "星空", "雪花", "雨滴", "森林", "花朵", "草莓", "柚子", "棉花", "天空", "氣泡", "旋風", "泡泡", "冰淇淋", "巧克力", "饅頭", "貝殼", "珊瑚", "沙灘", "波浪", "小貓頭", "雪豹", "雪人", "迷你熊", "冬瓜", "甜瓜", "月餅", "茶葉", "木棉", "椰子", "山楂", "鴛鴦", "小鳥", "鯨魚", "金魚", "草原", "深海", "礦石", "水晶", "珍珠", "翡翠", "琥珀", "藍寶", "星塵", "銀河", "曙光", "朝霞", "晚霞", "微塵", "小木偶", "小仙子", "精靈", "魔法師", "小巫師", "夜行者", "觀察者", "旅行家", "探險者", "漫步者", "拾荒者", "創造者", "造夢者", "築夢者", "流浪者"];
    const index = Math.floor(Math.random() * anonymousNicknames.length);
    const randomId = Math.floor(1000 + Math.random() * 9000); // 產生 1000 到 9999 的隨機編號
    return `TIES${anonymousNicknames[index]}#${randomId}`;
}

export const useWebStore = defineStore("web", {
    state: () => ({
        isMobile: null,
    }),
    actions: {
        setIsMobile(isMobile) {
            this.isMobile = isMobile;
        },
    },
});

export const useUserStore = defineStore("user", {
    state: () => ({
        userInfo: null,
        cookieNickName: null,
    }),
    actions: {
        // 設定會員資料
        setUserInfo(userData) {
            this.userInfo = { ...userData };
        },
        setNickName(NickName) {
            if (this.userInfo && this.userInfo.NickName != null) {
                this.userInfo.NickName = NickName;
            } else {
                Cookies.set(process.env.VUE_APP_NickNameKey, NickName);
                this.cookieNickName = NickName;
            }
        },
    },
    getters: {
        // 判斷是否登入
        isLogin(state) {
            return state.userInfo && Object.keys(state.userInfo).length > 0;
        },
        nickName(state) {
            const name = state.userInfo?.NickName ?? state.userInfo?.Name ?? state.cookieNickName;
            if (name) {
                return name;
            }
            const fromcookie = Cookies.get(process.env.VUE_APP_NickNameKey);
            if (fromcookie) {
                return fromcookie;
            }
            const newname = getRandomNickname();
            Cookies.set(process.env.VUE_APP_NickNameKey, newname);
            return newname;
        },
    },
});

export const useRoomStore = defineStore("room", {
    state: () => ({
        roomID: null,
        clientID: null,
        Roles: null,
    }),
    actions: {
        setRoomID(id) {
            this.roomID = id;
        },
        setClientID(id) {
            this.clientID = id;
        },
        setRoles(roles) {
            this.Roles = roles;
        },
    },
});

export const useBackendStore = defineStore("backend", {
    state: () => ({
        roomInfo: null,
        livestreamPermission: null,
    }),
    actions: {
        setRoomInfo(roomInfo) {
            this.roomInfo = roomInfo;
        },
        setLivestreamPermission(permission) {
            this.livestreamPermission = permission;
        },
    },
});
